/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceTrendRequestBase {
    getFixupPrototypeFunction() { return InfraResourceTrendRequestBase.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceTrendRequestBase>): InfraResourceTrendRequestBase {
        let obj = Object.assign(new InfraResourceTrendRequestBase(), model);
        InfraResourceTrendRequestBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceTrendRequestBase>): InfraResourceTrendRequestBase {
        if (!model) return null;
        return InfraResourceTrendRequestBase.newInstance(<InfraResourceTrendRequestBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceTrendRequestBase) {
        if (!obj) return;

        models.InfraResourceTrendRequestBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceTrendRequestBase): boolean {
        Object.setPrototypeOf(obj, InfraResourceTrendRequestBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Start date of the trend analysis period.
     */
    start_date: Date;

    /**
     * End date of the trend analysis period.
     */
    end_date: Date;

}
